//Gestion d'événements custom
var CustomEvents = (function(){
    'use strict';

    var eventloadLayer = null;
    var eventClosePopup = null;
    var eventCloseTooltip = null;
    var eventZoomEnd = null;
    var eventZoomStart = null;
    var eventResetLayer = null;
    var eventHighlightedFound = null;
    var eventGoToAddress = null;
    var eventChosenDate = null;

    var initializeEvents = function () {
        if(typeof Event === "function") {
            eventloadLayer = new Event('loadLayer');
            eventClosePopup = new Event('closePopup');
            eventCloseTooltip = new Event('closeTooltip');
            eventZoomEnd = new Event('zoomEnd');
            eventZoomStart = new Event('zoomStart');
            eventResetLayer = new Event('resetLayer');
            eventHighlightedFound = new Event('highlightedFound');
            eventGoToAddress = new Event('gotoAddress');
            eventChosenDate = new Event('chosenDate');
        }
        else { //pour IE
            eventloadLayer = document.createEvent('Event');
            eventClosePopup = document.createEvent('Event');
            eventCloseTooltip = document.createEvent('Event');
            eventZoomEnd = document.createEvent('Event');
            eventChangeMode = document.createEvent('Event');
            eventZoomStart = document.createEvent('Event');
            eventResetLayer = document.createEvent('Event');
            eventHighlightedFound = document.createEvent('Event');
            eventGoToAddress = document.createEvent('Event');
            eventChosenDate = document.createEvent('Event');

            eventloadLayer.initEvent('loadLayer', true, true);
            eventClosePopup.initEvent('closePopup', true, true);
            eventCloseTooltip.initEvent('closeTooltip', true, true);
            eventZoomEnd.initEvent('zoomEnd', true, true);
            eventZoomStart.initEvent('zoomStart', true, true);
            eventResetLayer.initEvent('resetLayer', true, true);
            eventHighlightedFound.initEvent('highlightedFound', true, true);
            eventGoToAddress.initEvent('gotoAddress', true, true);
            eventChosenDate.initEvent('chosenDate', true, true);
        }
    };

    var getEvent = function (nameEvent) {
        return eval(nameEvent);
    };

    var dispatchEvent = function (nameEvent) {
        var event = null;
        if(typeof nameEvent === "string") {
            event = eval(nameEvent);
        }
        else {
            event = nameEvent;
        }
        document.dispatchEvent(event);
    };

    return {
        getEvent:getEvent,
        dispatchEvent:dispatchEvent,

        init: function(){
            initializeEvents();
        }
    };

}());

$(document).ready(function() {
    CustomEvents.init();
});
